import classnames from "classnames";
import {PropsWithChildren} from "react";

import styles from "./SLAMetricBlock.module.css";

interface SLAMetricBlockProps extends PropsWithChildren {
  title: string;
  className?: string;
}

export const SLAMetricBlock = ({title, className, children}: SLAMetricBlockProps) => (
  <div className={classnames(className, styles.slaMetricBlock)}>
    <div>
      <span className="fs-6 text-muted text-uppercase">{title}</span>
      <div>{children}</div>
    </div>
  </div>
);
